export default "__VITE_ASSET__vMHjhv_u__"